import { queryOptions, useQuery } from "@tanstack/react-query";
import type { Plan } from "./types";
import { api } from "@/lib/http";

async function getPlans() {
  return await api.payment.get<Array<Plan>>("v1/plans/");
}

export const plansQueryOptions = queryOptions({
  queryKey: ["plans"],
  async queryFn() {
    const res = await getPlans();
    const data = await res.json();
    return { res, data };
  },
  select({ data }) {
    return data;
  },
});

export function usePlans() {
  return useQuery(plansQueryOptions);
}
